import axios from 'axios';
import { getApiBaseUrl } from '../apiBase';

function api() {
    const token = localStorage.getItem('token');
    return axios.create({
        baseURL: getApiBaseUrl(),
        headers: token ? { Authorization: `Bearer ${token}` } : {}
    });
}

export function listNomenclatureGroups(schoolId) {
    return api().get('/nomenclature-groups', { params: { schoolId } });
}

export function createNomenclatureGroup(schoolId, body) {
    return api().post('/nomenclature-groups', body, { params: { schoolId } });
}

export function updateNomenclatureGroup(id, schoolId, body) {
    return api().put(`/nomenclature-groups/${id}`, body, { params: { schoolId } });
}

export function deleteNomenclatureGroup(id, schoolId) {
    return api().delete(`/nomenclature-groups/${id}`, { params: { schoolId } });
}

export function listNomenclature(schoolId, groupId, includeArchived = false) {
    return api().get('/nomenclature', { params: { schoolId, groupId, includeArchived } });
}

export function getNomenclature(id, schoolId) {
    return api().get(`/nomenclature/${id}`, { params: { schoolId } });
}

export function createNomenclature(schoolId, body) {
    return api().post('/nomenclature', body, { params: { schoolId } });
}

export function updateNomenclature(id, schoolId, body) {
    return api().put(`/nomenclature/${id}`, body, { params: { schoolId } });
}

export function archiveNomenclature(id, schoolId) {
    return api().post(`/nomenclature/${id}/archive`, null, { params: { schoolId } });
}

export function getNomenclatureByBarcode(barcode, schoolId) {
    return api().get(`/nomenclature/by-barcode/${encodeURIComponent(barcode)}`, { params: { schoolId } });
}

export function getPosPanel(schoolId) {
    return api().get('/nomenclature/pos-panel', { params: { schoolId } });
}

export function getPosCatalog(categories) {
    return api().get('/pos-catalog', { params: { categories } });
}

export function getMeasurementUnits() {
    return api().get('/pos-catalog/measurement-units');
}

export function downloadImportTemplate() {
    return api().get('/nomenclature/import-template', { responseType: 'blob' });
}
